<proffeo-ui-dialog [title]="'task-filters.user-role-modal-title' | translate">
  <div class="flex flex-col gap-4">
    <proffeo-ui-select
      (valueChange)="selectedUserUserId.set($event)"
      [options]="userRoleOptions"
      [translateLabels]="false"
      [value]="selectedUserUserId()"
      label="task-filters.user-role-user"
      class="w-full"
    />

    <proffeo-ui-select
      (valueChange)="selectedIndustryAdminUserId.set($event)"
      [options]="industryAdminOptions"
      [translateLabels]="false"
      [value]="selectedIndustryAdminUserId()"
      label="task-filters.user-role-industry-admin"
      class="w-full"
    />

    <proffeo-ui-select
      (valueChange)="selectedGroupAdminUserId.set($event)"
      [options]="groupAdminOptions"
      [translateLabels]="false"
      [value]="selectedGroupAdminUserId()"
      label="task-filters.user-role-group-admin"
      class="w-full"
    />
  </div>
  <div
    dialog-actions
    class="flex w-full justify-end gap-2"
  >
    <proffeo-ui-button
      text="close"
      matDialogClose
    ></proffeo-ui-button>
    <proffeo-ui-button
      (clicked)="save()"
      variant="accent"
      text="common.save"
    ></proffeo-ui-button>
  </div>
</proffeo-ui-dialog>
